import { Helmet } from '@dr.pogodin/react-helmet';
import { Api } from 'src/api';
import { PageWrap, Stack, Text } from 'src/components';
import { Color } from 'src/constants';
import { useMyUserClient } from 'src/hooks';

import {
  AvailableTicketsSection,
  DashboardTabs,
  TicketsSection,
} from '../components';

export default function TicketsDashboardPage() {
  const myUser = useMyUserClient();

  const apiUntriaged = Api.Ticket.useReadCollectionUntriaged();
  const apiAwaitingReview = Api.Ticket.useReadCollectionAwaitingReview();

  return (
    <PageWrap background={Color.neutral5} noPadding limitWidth="small">
      <Helmet>
        <title>Tickets</title>
      </Helmet>

      <Stack padH={1.5} padV={1.5} gap={1.5}>
        <DashboardTabs selected="tickets" userId={myUser.id} />

        <Text typeface="headline" as="h1">
          Tickets
        </Text>

        <TicketsSection
          title="Untriaged Tickets"
          api={apiUntriaged}
          emptyMessage="Everything has been triaged"
        />

        <TicketsSection
          title="Awaiting Review"
          api={apiAwaitingReview}
          emptyMessage="Nothing is waiting on a review"
        />

        <AvailableTicketsSection taker={myUser} />
      </Stack>
    </PageWrap>
  );
}
